export const ifArrayThenString = (a: string | string[] | null | undefined) => {
  if (a && Array.isArray(a)) return a.join('');
  if (a) return a;
  return null;
};
